import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import MoneyField from 'common/Form/Fields/MoneyField';
import { usePaymentContext } from 'src/components/ClientProfile/PaymentTab/PaymentProvider';

const DepositField = ({ field, onBlur = () => {}, onChange, onFocus = () => {} }) => {
  const { maxAmount, minAmount, setDepositAmount } = usePaymentContext();

  const onChangeHandler = amount => {
    setDepositAmount(amount);
    onChange(amount);
  };

  useEffect(() => {
    if (minAmount && !!field.value && field.value < minAmount) {
      // We use queueMicrotask to schedule the state update after the current render cycle finishes.
      // This prevents the "Cannot update a component while rendering a different component" warning.
      queueMicrotask(() => {
        onChangeHandler(minAmount);
      });
    }
    // We intentionally exclude `field.value` to prevent overwriting the value while the user is typing.
    // This logic should only run on initialization or when the limit (minAmount) changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minAmount]);

  const handleBlur = useCallback(() => {
    if (maxAmount && field.value > maxAmount) {
      setDepositAmount?.(maxAmount);
      onChange(maxAmount);
    } else if (minAmount && field.value < minAmount) {
      setDepositAmount?.(minAmount);
      onChange(minAmount);
    }
    onBlur();
  }, [field.value, maxAmount, minAmount, onBlur, setDepositAmount, onChange]);

  return (
    <MoneyField field={field} onBlur={handleBlur} onChange={onChangeHandler} onFocus={onFocus} />
  );
};

DepositField.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default DepositField;
